import React from 'react';
import './ApplePayInfo.css';

export const ApplePayInfo = ({ applePayID }) => {
  return (
    <div className="applePayInfo" data-dd-privacy="mask" data-heap-redact-text>
      <img className="applePayThumb" src="/account/static/images/cards/applepay-logo.svg" alt="ApplePay" />
      <span className="applePayId">{applePayID}</span>
    </div>
  );
};
